import { Injectable } from '@angular/core';
import { map, Observable, of, ReplaySubject } from 'rxjs';
import { Company } from './company.model';
import { StorageKeysEnum } from '../enums/storage.keys.enum';
import { HttpService } from '../http/http.service';
import { NextMethodsEnum } from '../enums/next-methods.enum';

@Injectable({
    providedIn: 'root'
})
export class CompanyService {
    public readonly structureCompanyId = '00000034';
    public readonly missionCompanyId = '000000S2';
    
    private _company: ReplaySubject<Company> = new ReplaySubject<Company>(1);

    /**
     * Constructor
     */
    constructor(
        private _httpService: HttpService
    ) { }

    // -----------------------------------------------------------------------------------------------------
    // @ Accessors
    // -----------------------------------------------------------------------------------------------------

    /**
     * Setter & getter for company
     *
     * @param value
     */
    set company(value: Company) {
        localStorage.setItem(StorageKeysEnum.company, JSON.stringify(value));
        // Store the value
        this._company.next(value);
    }

    get company$(): Observable<Company> {
        return this._company.asObservable();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Get the current logged in user company data
     */
    get(): Observable<Company> {
        const company = JSON.parse(localStorage.getItem(StorageKeysEnum.company)) as Company;
        this._company.next(company);
        return of(company);
    }

    /**
     * Update the company
     *
     * @param user
     */
    update(company: Company): Observable<Company> {
        return this._httpService.post<any>(NextMethodsEnum.flushCompany, { company }).pipe(
            map((response) => {
                if (response && response.company) {
                    this._company.next(response.company);
                    localStorage.setItem(StorageKeysEnum.company, JSON.stringify(response.company));
                    return response.company;
                }
                return undefined;
            })
        );
    }

    delete() {
        localStorage.removeItem(StorageKeysEnum.company);
    }
}
